module.exports = __webpack_public_path__ + "img/book.b696a8a0.svg";